import { jsx } from 'react/jsx-runtime';
import { makeStyles } from '@material-ui/core/styles';
import { useState } from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles((theme) => ({
  button: {
    color: theme.palette.primary.light,
    textDecoration: "underline"
  }
}));
const TechDocsRedirectNotification = ({
  message,
  handleButtonClick,
  autoHideDuration
}) => {
  const classes = useStyles();
  const [open, setOpen] = useState(true);
  const handleClose = () => setOpen(false);
  return /* @__PURE__ */ jsx(
    Snackbar,
    {
      open,
      anchorOrigin: { vertical: "top", horizontal: "right" },
      autoHideDuration,
      color: "primary",
      onClose: handleClose,
      message,
      action: /* @__PURE__ */ jsx(
        Button,
        {
          classes: { root: classes.button },
          size: "small",
          onClick: () => {
            handleClose();
            handleButtonClick();
          },
          children: "Redirect now"
        }
      )
    }
  );
};

export { TechDocsRedirectNotification };
//# sourceMappingURL=TechDocsRedirectNotification.esm.js.map
